import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { installGridArrowNav } from "@/lib/gridNav";

installGridArrowNav();

// Stuur bezoekers die de app via een ander (oud) webadres openen door naar de officiële omgeving.
// Preview (test), localhost en het productiexl.online-domein zelf worden NOOIT doorgestuurd.
(function redirectNaarProductie() {
  try {
    const host = window.location.hostname;
    const veilig =
      host === "productiexl.online" ||
      host.endsWith(".preview.emergentagent.com") ||
      host === "localhost" ||
      host === "127.0.0.1" ||
      host.startsWith("192.168.") ||
      host.startsWith("10.");
    if (!veilig) {
      window.location.replace("https://productiexl.online" + window.location.pathname + window.location.search + window.location.hash);
    }
  } catch (e) { /* noop */ }
})();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
